<div class="cowing-input-container">
  <input
    #input
    [type]="'date'"
    [disabled]="disabled"
    [(ngModel)]="value"
    (ngModelChange)="onInputChange($event)"
  />
</div>
